import { actionGenerator, IReduxAction } from '../../utils/actions';
import { TDepositAccountPaymentStatus } from '../../reducers/depositAccount';

export const UPDATE_DEPOSIT_ACCOUNT_PAYMENT_STATUS = 'DEPOSIT_ACCOUNT :: UPDATE_PAYMENT_STATUS';

export type TUpdateDepositAccountPaymentStatusAction = IReduxAction<
  typeof UPDATE_DEPOSIT_ACCOUNT_PAYMENT_STATUS,
  TDepositAccountPaymentStatus
>;

export const updateDepositAccountPaymentStatus = actionGenerator<
  typeof UPDATE_DEPOSIT_ACCOUNT_PAYMENT_STATUS,
  TDepositAccountPaymentStatus
>(UPDATE_DEPOSIT_ACCOUNT_PAYMENT_STATUS);
